export { Routes as DefaultRoutes } from './Routes';
